<template>
  <div :class="$style['select-lab-order-dialog']" v-if="dialogVisible">
    <el-dialog width="90%" :visible="dialogVisible" title="" @close="cancel">
      <pt-gene-lab-order :hideBtn="true" @selection-change="updateSelectedData" :noExportOption="noExportOption" :selectedKeys="selectedKeys" :hideTitle="true" :billId="billId" :taskId="taskId" :filterAssginPre="filterAssginPre" :isDialog="true" :onlyNoBill="onlyNoBill" :orderStatusEnum="orderStatusEnum"></pt-gene-lab-order>
      <div class="button-div">
        <el-button type="primary" @click="submit">选择</el-button>
        <el-button type="primary" plain @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ptGeneLabOrder from 'cps/lab-order/pt-gene-lab-order'
export default {
  name: 'default-package-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: [String, Array],
      default: ''
    },
    billId: {
      type: String,
      default: ''
    },
    taskId: {
      type: String,
      default: ''
    },
    // 是否只显示分派预选的样品
    filterAssginPre: {
      type: Boolean,
      default: false
    },
    // 是否只显示没有委托单的样品
    onlyNoBill: {
      type: Boolean,
      default: false
    },
    // 筛选状态
    orderStatusEnum: String,
    // 没有导出相关操作
    noExportOption: Boolean
  },
  components: {
    ptGeneLabOrder
  },
  data () {
    return {
      select_row: null
    }
  },
  watch: {
  },
  methods: {
    updateSelectedData (data) {
      this.select_row = data
    },
    submit () {
      if (this.selectedKeys && !this.select_row) {
        this.cancel()
        return
      }
      console.log('---1')
      this.$emit('selectData', this.select_row)
    },
    cancel () {
      this.$emit('close')
    }

  }
}
</script>
<style module lang="less">
@import "~less/var";
.select-lab-order-dialog{
    :global
    .el-pagination{
        justify-content: flex-start!important;
    }
     :global
    .el-radio__label{
        display: none;
    }
    :global
    .el-radio__inner{
        border:1px solid #409eff;
        border-radius:50%
    }
}
</style>
